import { variantOnSale } from '@/utils/shopify';

export const formatRating = (ratingValue) => (ratingValue ? Number(ratingValue).toFixed(1) : null);

/**
 * EEC representation of product
 */
export const buildEECProduct = (variant, product, quantity, imageUrl = null) => ({
  item_name: product.title,
  item_id: variant.sku,
  price: parseFloat(variant.price?.amount || variant.price),
  item_brand: variantOnSale(variant),
  item_category: product.productType,
  item_variant: variant.title,
  quantity: quantity ?? 1,
  imageUrl,
});
